const PRO_WHITE = {
  name: 'White Outline',
  font: "montserrat",
  fontColor: "#2c3e50",
  fontColor2: "#2c3e50",
  bgColor: "#FFFFFF",
  accentColor: "#1DA1F2",
  panelColor: "#FFFFFF",
  button_fontColor: "#2c3e50",
  button_bgColor: "#FFFFFF",
  button_border: "#e5e7eb",
  borderColor: "#e7e3e3",
  selectedColor: "#6e8bff",
};

const SAASTER = {
  name: 'SaaSter',
  font: "roboto",
  fontColor: "#444444",
  fontColor2: "#14171A",
  bgColor: "#fafbfc",
  accentColor: "#FF6A88",
  panelColor: "#FFFFFF",
  button_fontColor: "#FFFFFF",
  button_bgColor: "#1DA1F2",
  button_border: "#1DA1F2",
  borderColor: "#d8d8d8",
  selectedColor: "#1DA1F2",
};

const PRO_BLUE = {
  name: 'Dark Blue',
  font: "montserrat",
  fontColor: "#FFFFFF",
  fontColor2: "#2c3e50",
  bgColor: "#3D556E",
  accentColor: "#FF6A88",
  panelColor: "#FFFFFF",
  button_fontColor: "#FFFFFF",
  button_bgColor: "#3CC49C",
  button_border: "#3CC49C",
  borderColor: "#d8d8d8",
  selectedColor: "#6e8bff",
};

const BROWN_BETTY = {
  name: 'Brown Betty',
  font: "open_sans",
  fontColor: "#FAB3A9",
  fontColor2: "#2c3e50",
  bgColor: "#463239",
  accentColor: "#ED6B86",
  panelColor: "#FFFFFF",
  button_fontColor: "#FFFFFF",
  button_bgColor: "#57b894",
  button_border: "#57b894",
  borderColor: "#d8d8d8",
  selectedColor: "#57b894",
};

const BLUE_BETTY = {
  name: 'Light Blue',
  font: "roboto",
  fontColor: "#1A3A4B",
  fontColor2: "#1A3A4B",
  bgColor: "#CAE9FF",
  accentColor: "#00C6AF",
  panelColor: "#FFFFFF",
  button_fontColor: "#FFFFFF",
  button_bgColor: "#00A1F3",
  button_border: "#00A1F3",
  borderColor: "#d8d8d8",
  selectedColor: "#6e8bff",
};

const GREEN_JOE = {
  name: 'Green Joe',
  font: "poppins",
  fontColor: "#FFFFFF",
  fontColor2: "#05386B",
  bgColor: "#57b894",
  accentColor: "#FA875F",
  panelColor: "#FFFFFF",
  button_fontColor: "#FFFFFF",
  button_bgColor: "#57b894",
  button_border: "#FFFFFF",
  borderColor: "#d8d8d8",
  selectedColor: "#6e8bff",
};

const APPSTER = {
  name: 'Appster',
  font: "noto_sans",
  fontColor: "#FFFFFF",
  fontColor2: "#14171A",
  bgColor: "#1DA1F2",
  accentColor: "#FF6A88",
  panelColor: "#FFFFFF",
  button_fontColor: "#FFFFFF",
  button_bgColor: "#1da1f21a",
  button_border: "#FFFFFF",
  borderColor: "#d8d8d8",
  selectedColor: "#6e8bff",
};

import Survey from "@/models/Survey";

export const ColorSchemes = {
  computed: {
    schemes(){
        return { PRO_WHITE, SAASTER, PRO_BLUE, BLUE_BETTY  }
    },
  },
  methods: {
    applyTemplate(template) {
      Survey.update({
        where: this.survey.id,
        data: {
          font: template.font,
          fontColor: template.fontColor,
          fontColor2: template.fontColor2,
          bgColor: template.bgColor,
          accentColor: template.accentColor,
          panelColor: template.panelColor,
          buttonFontColor: template.button_fontColor,
          buttonBgColor: template.button_bgColor,
          buttonBorderColor: template.button_border,
          borderColor: template.borderColor,
          selectedColor: template.selectedColor,
        },
      });

    },
  },
};
